'use client'

import { forbidden } from 'next/navigation'
import { useState, useTransition } from 'react'

import { sendWithdrawalRequest } from './actions/send-withdrawal-request'

interface Props {
  assignedProductId: string
}

export function useWithdrawalAction({ assignedProductId }: Props) {
  const [submittedRequestedAt, setSubmittedRequestedAt] = useState<string | null>(null)
  const [isError, setIsError] = useState(false)
  const [isPending, startTransition] = useTransition()

  const handleConfirm = () => {
    setIsError(false)
    startTransition(async () => {
      try {
        const result = await sendWithdrawalRequest({ assignedProductId })
        setSubmittedRequestedAt(result.requestedAt)
      } catch (error) {
        if (error instanceof Error && error.message === 'UNAUTHENTICATED') {
          forbidden()
        } else {
          setIsError(true)
        }
      }
    })
  }

  return { submittedRequestedAt, isLoading: isPending, isError, handleConfirm }
}
